var R = /* @__PURE__ */ ((r) => (r.PRIMARY = "primary", r.SECONDARY = "secondary", r.TERTIARY = "tertiary", r.TERTIARY_WITH_BACKGROUND = "tertiary-with-background", r.LINK = "link", r))(R || {});
export {
  R as ButtonVariant
};
